import Vue from 'vue'
import VueRouter from 'vue-router'
import StartView from '@/views/StartView'
import store from '@/store'
import _ from 'lodash'

Vue.use(VueRouter)

const ADMIN_ROLE = process.env.VUE_APP_ADMIN_ROLE

const routes = [
  // ==== Allgemein ====
  {
    path: '/',
    name: 'start',
    component: StartView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/loggedout',
    name: 'loggedout',
    component: () => import(/* webpackChunkName: "loggedout" */ '../views/LoggedOut.vue')
  },
  {
    path: '/errorlogin',
    name: 'errorlogin',
    component: () => import(/* webpackChunkName: "errorlogin" */ '../views/ErrorLogin.vue')
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import(/* webpackChunkName: "unauthorized" */ '../views/UnauthorizedView.vue')
  },
  // ==== Admin ====
  {
    path: '/encore/:tab?/:id?',
    name: 'encore',
    props: true,
    component: () => import(/* webpackChunkName: "encore" */ '../views/EncoreAdmin.vue'),
    meta: { authorize: [ADMIN_ROLE] }
  },
  // ==== Nutzer ====
  {
    path: '/user/mandatory',
    name: 'mandatory',
    component: () => import(/* webpackChunkName: "user" */ '../views/MandatoryTasks.vue')
  },
  {
    path: '/policy/user',
    name: 'policyUser',
    component: () => import(/* webpackChunkName: "policyUser" */ '../views/PolicyUser.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */ '../views/UserView.vue')
  },
  {
    path: '/password/change/',
    name: 'passwordChange',
    component: () => import(/* webpackChunkName: "password" */ '../views/PasswordChange.vue')
  },
  {
    path: '/mfa/overview',
    name: 'mfaOverview',
    component: () => import(/* webpackChunkName: "mfa" */ '../views/MfaOverview.vue')
  },
  {
    path: '/mfa/create',
    name: 'mfaCreate',
    component: () => import(/* webpackChunkName: "mfa" */ '../views/MfaCreate.vue')
  },
  {
    path: '/email',
    name: 'emailOverview',
    component: () => import(/* webpackChunkName: "mfa" */ '../views/EmailOverview.vue')
  },
  {
    path: '/unicard',
    name: 'uniCard',
    component: () => import(/* webpackChunkName: "mfa" */ '../views/UniCard.vue')
  },
  // ==== Public ====
  {
    path: '/activate',
    name: 'activate',
    component: () => import(/* webpackChunkName: "activation" */ '../views/public/ActivateUser.vue')
  },
  {
    path: '/password/mailconfirm/:token?',
    name: 'passwordMailConfirm',
    component: () => import(/* webpackChunkName: "recoveryMailConfirm" */ '../views/public/PasswordMailConfirm.vue')
  },
  {
    path: '/password/recovery/',
    name: 'passwordRecovery',
    component: () => import(/* webpackChunkName: "password" */ '../views/public/PasswordRecovery.vue')
  },
  {
    path: '/password/reset/:token?',
    name: 'passwordReset',
    component: () => import(/* webpackChunkName: "password" */ '../views/public/PasswordReset.vue')
  },
  {
    path: '/404',
    alias: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // console.log('=================================')
  const { authorize } = to.meta // gleiches wie folgend:
  // const authorize = to.meta.authorize
  const publicPages = [
    '/',
    '/start',
    '/loggedout',
    '/errorlogin',
    '/unauthorized',
    '/login'
  ]
  const authRequired = !(
    publicPages.includes(to.path) ||
    to.path.startsWith('/activate') ||
    to.path.startsWith('/password/reset/') ||
    to.path.startsWith('/password/recovery') ||
    to.path.startsWith('/password/mailconfirm/')
  )
  const mandatoryNotAllowed = !(
    to.path === '/' ||
    to.path.startsWith('/user/mandatory') ||
    to.path.startsWith('/password/change') ||
    to.path.startsWith('/policy/user') ||
    to.path.startsWith('/mfa')
  )

  if (!store.state.auth.user) {
    await store.dispatch('auth/ping')
  }

  const user = store.state.auth.user
  const loggedIn = Boolean(user)

  let pass = true
  if (loggedIn) {
    const roles = user.roles || []
    const mandatory = user.mandatory || []

    if (authorize && _.intersection(roles, authorize).length === 0) {
      pass = false
    }

    if (Array.isArray(mandatory) && mandatory.length > 0) {
      if (mandatoryNotAllowed) {
        next('/user/mandatory')
        return
      }
    }
  }

  if (!pass || (authRequired && !loggedIn)) {
    if (to.fullPath !== '/' && to.fullPath !== '/start') {
      store.commit('auth/redirectAfterLogin', to.fullPath)
    }
    next('/unauthorized')
  } else {
    next()
  }
})

export default router
